import clsx from "clsx";
import { FC } from "react";
import { useMoney } from "../../hooks/useMoney";
import { mergeClass } from "../../utils/common";

export const ProdPricing: FC<
  ProductBaseResponse & {
    className?: string;
    vari?: "WHITE" | "BLACK";
  }
> = ({ className, vari = "BLACK", ...product }) => {
  const { formatMoney } = useMoney();
  return (
    <div className={mergeClass("flex items-center", className)}>
      <span className={clsx("prod-price", "vari-" + vari)}>
        {formatMoney(product.price)}

        {product.originalPrice && product.price !== product.originalPrice && (
          <span className="prod-price--original">
            {formatMoney(product.originalPrice)}
          </span>
        )}
        {product.displayPriceType === "FIXED" ? (
          <span> </span>
        ) : (
          <span> ~ </span>
        )}
      </span>
    </div>
  );
};
